/**
 * Static-catalog PDP helpers (variant/size matrix). API fields can populate `colorSizeMap` later.
 * Values are truthy = available for that colour + size (maison-pattern).
 */

export function enrichCatalogProduct(product) {
  if (!product) return null;
  if (
    product.colorSizeMap &&
    typeof product.colorSizeMap === 'object' &&
    Object.keys(product.colorSizeMap).length
  ) {
    return product;
  }
  const sizes = Array.isArray(product.sizes) ? product.sizes : [];
  const colors = Array.isArray(product.colors) ? product.colors : [];
  const colorSizeMap = {};
  colors.forEach((c) => {
    const name = typeof c === 'string' ? c : c?.name;
    if (!name) return;
    colorSizeMap[name] = {};
    sizes.forEach((s) => {
      colorSizeMap[name][s] = true;
    });
  });
  return { ...product, colorSizeMap };
}

export function isSizeAvailable(product, colorName, sizeName) {
  if (!product || !colorName || !sizeName) return false;
  if (!product.colorSizeMap || !Object.keys(product.colorSizeMap).length) return true;
  const row = product.colorSizeMap[colorName];
  if (!row) return false;
  const cell = row[sizeName];
  if (cell === false || cell === null || cell === undefined) return false;
  return true;
}
